import {
	UserWithIsActive,
	useTeam,
} from '@/providers/TeamProvider/TeamProvider';

export function useUserAvatar(userId: string): UserWithIsActive | undefined {
	const {
		team: { members },
	} = useTeam();

	const user = members.find((m) => m.user.id === userId)?.user;

	return user;
}
